export function prefixFilterRules(value) {
    return value && value.replace(/^[0-9]/g, '').replace(/\W/g, '');
}
